import styles from "./EmailStage.module.css"
import { useState } from 'react';
import EmailInput from "../../../../../components/Input/EmailInput/EmailInput";
import SubmitButton from "../../../../../components/Button/SubmitButton/SubmitButton";
import { useTranslation } from "react-i18next";
/**
* Props for the EmailStage component.
*/ 
interface EmailStageProps {
    onSubmit: (email: string) => void; // Password reset submit handler
}
/**
* Forgot password reset email stage.
* Contains the password reset form.
*
* @param props EmailStageProps
* @param {(email: string) => void} props.onSubmit - Password reset submit handler
* @returns TSX.Element
*/
const EmailStage = ({onSubmit}: EmailStageProps) => {
    const { t } = useTranslation(); // Translation
    const [email, setEmail] = useState("") // Current email
    
    return(
        <>
        <div className={styles.FormSubtitle}><p>{t("forgot_password.subtitle")}</p></div>
        <div className={styles.FormBlock}>
            <form action="" className={styles.Form} onSubmit={(e)=>{
                e.preventDefault();
                onSubmit(email);
            }}>
                <div className={styles.InputCapsule}>
                    <EmailInput onChange={setEmail} email={email}/>
                </div>
                <SubmitButton text={t("buttons.send")}/>
            </form>
        </div>
        </>
    )
};

export default EmailStage;
